var map = {
	"./en.json": 389,
	"./es.json": 8302,
	"./med-quindio/en.json": 7720,
	"./med-quindio/es.json": 7439,
	"./med-rd/en.json": 2265,
	"./med-rd/es.json": 7578,
	"./msj/en.json": 3478,
	"./msj/es.json": 8157,
	"./private/en.json": 5949,
	"./private/es.json": 3766
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6057;